export const PASS_BUILDER_PUBLISHED_MESSAGE_TYPE =
  "cherryhub.pass-builder.published";

const getPassBuilderOrigin = (passBuilderUrl: string): string | null => {
  try {
    return new URL(passBuilderUrl).origin;
  } catch {
    return null;
  }
};

export const isPassBuilderPublishedMessage = (
  event: MessageEvent,
  passBuilderUrl: string
): boolean => {
  if (event.data?.type !== PASS_BUILDER_PUBLISHED_MESSAGE_TYPE) {
    return false;
  }

  const expectedOrigin = getPassBuilderOrigin(passBuilderUrl);
  return expectedOrigin != null && event.origin === expectedOrigin;
};
